export const CircleIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 100 100">
      <circle cx="50" cy="50" r="40" fill="#fff" stroke="#333" strokeWidth="2" />
    </svg>
  );
};
